module.exports = __webpack_public_path__ + "94dac78eee406a8c8f0406b69b85ac2b.woff";